import BindPositioningDevicesModal from './bind-positioning-devices-modal.vue'
export default BindPositioningDevicesModal
